import { useAuthStore } from "@/store/auth.store";
import { PlanName } from "@/common/enums/enums";
import SetupSubscription from "./components/SetupSubscription";
import ManageSubscription from "./components/ManageSubscription";

export default function SubscriptionSettings(): JSX.Element {
  const { userData } = useAuthStore();
  if (userData?.planName == PlanName.FREE_TRIAL) {
    return <SetupSubscription />;
  }
  return <ManageSubscription userData={userData!} />;
}
